import { NewsroomSideBarItemModel } from './newsroom-side-bar-item.model';

export class NewsroomSideBarModel {
    public items: NewsroomSideBarItemModel[] = [];
    public totalItemCount: number = 0;
}
